"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageBus = void 0;
/*
 * Allows using 'sendRequest' and awaiting a response via the Window.postMessage API.
 * Must call 'connect' before use, and 'disconnect' afterward to remove listeners.
 */
class MessageBus {
    constructor(provider, targetOrigin) {
        this.requestHandlers = new Map();
        this.handleIncomingMessage = (event) => {
            if (event.source === top) {
                // event.data is the entire payload of the event
                const payload = event.data;
                // the 'data' key within the payload indicates success
                // while the 'error' key within the payload indicates an error
                if (payload.data && payload.id) {
                    this.resolveRequest(payload.id, payload.data);
                }
                else if (payload.error) {
                    this.rejectRequest(payload.id, new Error(payload.error));
                }
            }
        };
        this.connect = () => {
            if (!window)
                throw new Error("MessageBus runs client-side only");
            if (this.connected)
                return;
            window.addEventListener("message", this.handleIncomingMessage);
            this.connected = true;
        };
        this.sendRequest = (id, method, params = {}) => __awaiter(this, void 0, void 0, function* () {
            if (!this.connected)
                throw new Error("MessageBus is not connected");
            return yield new Promise((resolve, reject) => {
                this.requestHandlers.set(id, [resolve, reject]);
                this.provider.postMessage({
                    id,
                    method,
                    payload: Object.assign({}, params)
                }, this.targetOrigin);
            });
        });
        this.resolveRequest = (requestID, value) => {
            const handlers = this.requestHandlers.get(requestID);
            if (!handlers)
                return;
            const [resolve] = handlers;
            resolve((value === null || value === void 0 ? void 0 : value.txSignature) ? value.txSignature : value);
        };
        this.rejectRequest = (requestID, reason) => {
            const handlers = this.requestHandlers.get(requestID);
            if (!handlers)
                return;
            const [, reject] = handlers;
            reject(reason);
        };
        this.disconnect = () => {
            if (!this.connected)
                return;
            this.requestHandlers.forEach(([, reject], id) => {
                this.requestHandlers.delete(id);
                reject(new Error("Wallet disconnected"));
            });
            window.removeEventListener("message", this.handleIncomingMessage);
            this.connected = false;
        };
        this.provider = provider;
        this.connected = false;
        this.targetOrigin = targetOrigin;
    }
}
exports.MessageBus = MessageBus;
